import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import Image from 'next/image';
const SidebarToggle = ({ collapseIcon, expandIcon, isCollapsed, onToggle, className })=>{
    const baseDataTestId = 'SidebarToggle';
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(toggleStyle, className),
        "data-testid": `${baseDataTestId}-button`,
        onClick: onToggle,
        children: /*#__PURE__*/ _jsx(Image, {
            className: iconStyle,
            src: isCollapsed ? expandIcon : collapseIcon,
            alt: isCollapsed ? 'Sidebar Expand' : 'Sidebar Collapse',
            width: 24,
            height: 24
        })
    });
};
export default SidebarToggle;
const toggleStyle = 'absolute flex justify-center items-center w-8 h-8 rounded-full border border-lightGrey3 bottom-28 -right-4 bg-baseWhite cursor-pointer hover:bg-lightGrey4 active:bg-toggleButtonPressed';
const iconStyle = 'text-transparent';
